import React from 'react';
import ImageComponent from './ImageComponent';
import './PromoComponent.css';
// Importiere die Bilder
import appStoreLogo from './assets/app-store-badge.svg';
import playStoreLogo from './assets/google-play-badge.png';

const PromoComponent: React.FC = () => {
    return (
        <div className="promo-container">
            <div className="promo-content">
                <h1>Download the AI-Chef App now</h1>
                <p>TRY IT FOR FREE</p>
            </div>
            <div className="store-logos">
                <a href="https://play.google.com/store/apps/details?id=com.oeppe.aichef&pcampaignid=web_share" target="_blank" rel="noopener noreferrer" className="image-container">
                    <ImageComponent src={playStoreLogo} alt="Google Play Store" />
                </a>
                <a href="https://apps.apple.com/at/app/ai-chef/id6475085351" target="_blank" rel="noopener noreferrer" className="image-container">
                    <ImageComponent src={appStoreLogo} alt="App Store" />
                </a>
            </div>
        </div>
    );
};

export default PromoComponent;

